/*eslint eqeqeq: "off"*/
import React, { useContext, useMemo, useState } from "react";
import { styled } from "@mui/material/styles";
import { Box, Button, Checkbox, FormControlLabel, FormHelperText, Grid, IconButton, InputAdornment, TextField, Typography, useTheme } from "@mui/material";
import { makeStyles } from "@material-ui/core";
import { pxToRem } from "../../theme/typography";
import GoogleIcon, { NewGoogleIcon } from "../../assets/images/icon/google-icon";
import FacebookIcon, { NewFacebookIcon } from "../../assets/images/icon/facebook-icon";
import { Link, useNavigate } from "react-router-dom";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { useFormik } from "formik";
import * as yup from "yup";
import palette from "../../theme/palette";
import SnackBarComp from "../../components/snackBar";
import { userService } from "../../services/auth";
import { facebookProvider, googleProvider } from "../../config/authMethods";
import FullpageLoader from "../../components/fullPageLoader";
import { ButtonLoader } from "../../components/buttonLoader";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { auth } from "../../config/firebase";
import {
  CreateUserModal,
  USerContinueRegister,
} from "../../interfaces/outcomeModal";
import { setUserToken } from "../../store/actions/userTypeAction";
import { UserTypeContext } from "../../context/userStatus";
import VisibilityOffOutlined from "@mui/icons-material/VisibilityOffOutlined";
import VisibilityOutlined from "@mui/icons-material/VisibilityOutlined";
import queryParams from "../../utils/getQueryParams";
import CommonTypo from "../../components/CommonTypo";

const validationSchema = yup.object({
  fname: yup.string().required("First name is required"),
  lname: yup.string().required("Last name is required"),
  email: yup
    .string()
    .email("Enter a valid email")
    .required("Email is required"),
  password: yup
    .string()
    .min(8, "Password should be of minimum 8 characters length")
    .required("Password is required"),
  terms_condition: yup
    .boolean()
    .required('You must accept the Terms of Service to proceed')
    .oneOf([true], 'Error')
});

const RootStyle = styled("div")(({ theme }) => ({
  justifyContent: "center",
  display: "flex",
  flexDirection: "column",
  gap: "22px",
  padding: "0 !important",
  [theme.breakpoints.up("xl")]: {
    padding: "60px",
  },
  [theme.breakpoints.down("lg")]: {
    padding: "40px",
  },
  [theme.breakpoints.down("md")]: {
    padding: "30px",
  },
  [theme.breakpoints.down("sm")]: {
    padding: "20px",
  },
}));
const RootStyle2 = styled("div")(({ theme }) => ({
  padding: "0 100px",
  [theme.breakpoints.up("xl")]: {
    padding: "60px",
  },
  [theme.breakpoints.down("lg")]: {
    padding: "40px",
  },
  [theme.breakpoints.down("md")]: {
    padding: "30px",
  },
  [theme.breakpoints.down("sm")]: {
    padding: "0px",
  },
}));

const useStyles = makeStyles((theme) => ({
  registrationHeading: {
    color: palette.primary.light,
    marginBottom: "62px!important",
    textAlign: "center",
    [theme.breakpoints.down("xl")]: {
      marginBottom: "50px!important",
    },
    [theme.breakpoints.down("md")]: {
      marginBottom: "40px!important",
    },
    [theme.breakpoints.down("sm")]: {
      marginBottom: "30px!important",
    },
  },
  socialLoginButton: {
    marginTop: "36px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "24px"
  },
  socialLoginButtonWeb: {
    marginTop: pxToRem(22),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "24px"
  },
  alreadyAccountText: {
    marginTop: "36px",
    color: "#3E4240",
    fontSize: pxToRem(16),
    lineHeight: pxToRem(16),
    fontWeight: 400,
    textAlign: "center",

  },
  alreadyAccountTextSpan: {
    color: "#11734A",
    cursor: "pointer",
    [theme.breakpoints.up("md")]: {
      textDecoration: "underline"
    },
  },
  textInputMobile: {
    "& .MuiOutlinedInput-root": {
      border: "1px solid #B8E29E",
      '& .MuiInputBase-input': {
        '&::placeholder': {
          fontSize: `${pxToRem(14)} !important`,
          color: '#3E4240',
          opacity: 1, /* Firefox */
          lineHeight: '100%',
          fontWeight: 400,
        }
      },
    },

  }
}));

const ariaLabel = { "aria-label": "description" };

const RightPartRegistration = ({ isMobile = false, newFlow = false, anonymousID = null, registerCallback = (x: any) => { } }) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const queryData = queryParams()
  const [showSnakbar, setShowSnakbar] = useState(false);
  const [showLoaderPage, setShowLoaderPage] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [snakbarMsg, setSnakbarMsg] = useState("");
  const [msgType, setMsgType] = useState("");
  const { state: IUserTypeState, dispatch: userTypeDispatch } = useContext(UserTypeContext);
  const isDarkMode = useTheme().palette.mode === "dark" || IUserTypeState.isDarkMode
  // FIREBASE AUTHENTICATION
  const emailAuth = async (email: string, password: string) => {
    return createUserWithEmailAndPassword(auth, email, password)
      .then((result) => {
        localStorage.setItem("userDetails", JSON.stringify(result));
        return result;
      })
      .catch((err) => {
        setShowLoader(false);
        setShowSnakbar(true);
        setMsgType("error");
        if (err.code == "auth/email-already-in-use") {
          setSnakbarMsg("User with this email already exist");
        } else {
          setSnakbarMsg(err.message);
        }
        return err;
      });
  };

  // REGISTER API
  const userContinueRegister = (values: USerContinueRegister) => {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    const userData = {
      uid: userDetails?.user?.uid ? userDetails?.user?.uid : userDetails?.uid,
      user_email: userDetails?.user?.email
        ? userDetails?.user?.email
        : userDetails?.email,
      signUpType:
        userDetails?.providerData?.[0]?.providerId == "google.com"
          ? "GMAIL"
          : userDetails?.providerData?.[0]?.providerId == "facebook.com"
            ? "FACEBOOK"
            : "OTHER",
      first_name: values.fname,
      last_name: values.lname,
      "ipAddress": localStorage.getItem("ipAddress"),
      "token": localStorage.getItem("currentToken"),
      "deviceTokenType": localStorage.getItem("deviceType"),
      "deviceType": localStorage.getItem("deviceType") === "Desktop" ? "WEB" : localStorage.getItem("deviceType") === "AndroidMobile" ? "ANDROID" : localStorage.getItem("deviceType") === "iOSMobile" ? "IOS" : null,
      "browserName": localStorage.getItem("browserName"),
      anonymousID,
    };
    userService
      .createUser(userData)
      .then((data: CreateUserModal) => {
        localStorage.removeItem("anonymous-user-id")
        localStorage.setItem("userValues", JSON.stringify(data.data));
        localStorage.setItem("userDetails", data["x-access_token"]);
        userTypeDispatch(setUserToken(data["x-access_token"]));
        if (newFlow) {
          registerCallback(data)
        } else {
          navigate("/user-identification" + queryData.qeryString);
        }
      })
      .catch((error) => {
        setShowLoader(false);
        setShowLoaderPage(false);
        setMsgType("error");
        setShowSnakbar(true);
        setSnakbarMsg(error?.response?.data?.description);
      });
  };

  const firebaseLogin = async (values: USerContinueRegister) => {
    setShowLoader(true);
    try {
      const result = await emailAuth(values.email, values.password);
      if (result.user) {
        userContinueRegister(values);
      }
    } catch (error) {
      setShowLoader(false);
    }
  };

  const formik = useFormik({
    initialValues: {
      fname: "",
      lname: "",
      email: "",
      password: "",
      terms_condition: false
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      setShowLoader(true);
      firebaseLogin(values);
    },
  });
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

  const handleCloseSnakbar = () => {
    setShowSnakbar(false);
  };
  const handleOnClick = async (provider: any) => {
    setShowLoaderPage(true);
    try {
      const result = await userService.socialMediaAuth(provider);
      if (!result.uid) {
        setShowLoaderPage(false);
        throw new Error(result.message);
      } else {
        const splittedName = result?.displayName ? result.displayName?.split(" ") : []
        result.fname = splittedName[0] || undefined
        result.lname = splittedName[1] || undefined
        localStorage.setItem("userDetails", JSON.stringify(result));
        userContinueRegister(result);
      }
    } catch (error) {
      setShowLoaderPage(false);
      setMsgType("error");
      setShowSnakbar(true);
      setSnakbarMsg(error.message);
    }
  };
  let obj = {}
  if (!isMobile) {
    obj = {
      padding: "15px 100px 0"
    }
  }
  const Root = useMemo(() => isMobile ? RootStyle2 : RootStyle, [isMobile]);
  return (
    <Root className="login-right-part" sx={newFlow ? {} : {
      height: "95vh",
      ...obj
    }}>
      {showLoaderPage && <FullpageLoader />}
      <SnackBarComp
        showSnakbar={showSnakbar}
        handleCloseSnakbar={handleCloseSnakbar}
        snakbarMsg={snakbarMsg}
        type={msgType ? msgType : "info"}
      />
      {newFlow && !isMobile && (
        <Box sx={{
          display: "flex",
          flexDirection: "column",
          gap: "8px",
          alignItems: "center"
        }}>
          <CommonTypo size={32} fontWeight={700} color="var(--color-text-primary)" lineHeight={36} extraSx={{
            whiteSpace: "nowrap"
          }}>Your plan is ready</CommonTypo>
          <CommonTypo size={16} fontWeight={400} color="var(--color-text-secondary)" lineHeight={22} >Sign up to save it and start the journey</CommonTypo>

        </Box>
      )}
      {!isMobile && !newFlow && <Typography
        variant="h1"
        component="h1"
        className={classes.registrationHeading}
      >
        {/* Sign up and get started today! */}
        Create an account
      </Typography>}
      <Grid padding={isMobile ? "60px 0 0" : ""} className="hide-scrollbar" sx={newFlow ? {
        display: "flex",
        flexDirection: "column",
        gap: "8px",
        alignItems: "center"
      } : isMobile ? {

      } : {
        maxHeight: "90%",
        overflowY: "auto",

      }}>
        <form onSubmit={formik.handleSubmit} style={newFlow ? {
          display: "flex",
          flexDirection: "column",
          gap: "8px",
          alignItems: "center",

        } : {}}>
          {newFlow ? (
            <Box sx={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              width: "100%"
            }}>
              <TextField
                placeholder={newFlow ? "First Name" : "First name"}
                variant="outlined"
                fullWidth
                name="fname"
                value={formik.values.fname}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                className={isMobile ? classes.textInputMobile : "newInputBoxv2"}
                error={formik.touched.fname && Boolean(formik.errors.fname)}
                helperText={formik.touched.fname && formik.errors.fname}
                inputProps={ariaLabel}
              />
              <TextField
                placeholder={newFlow ? "Last Name" : "Last name"}
                variant="outlined"
                fullWidth
                name="lname"
                value={formik.values.lname}
                className={isMobile ? classes.textInputMobile : "newInputBoxv2"}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.lname && Boolean(formik.errors.lname)}
                helperText={formik.touched.lname && formik.errors.lname}
                inputProps={ariaLabel}
              />
            </Box>
          ) : <>
            <TextField
              placeholder="First name"
              variant="outlined"
              fullWidth
              name="fname"
              value={formik.values.fname}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              className={isMobile ? classes.textInputMobile : "newInputBox"}
              error={formik.touched.fname && Boolean(formik.errors.fname)}
              helperText={formik.touched.fname && formik.errors.fname}
              inputProps={ariaLabel}
            />
            <TextField
              placeholder="Last name"
              variant="outlined"
              fullWidth
              name="lname"
              value={formik.values.lname}
              className={isMobile ? classes.textInputMobile : "newInputBox"}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.lname && Boolean(formik.errors.lname)}
              helperText={formik.touched.lname && formik.errors.lname}
              inputProps={ariaLabel}
            />
          </>}

          <TextField
            placeholder="Email"
            variant="outlined"
            fullWidth
            name="email"
            value={formik.values.email}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className={isMobile ? classes.textInputMobile : (newFlow ? "newInputBoxv2" : "newInputBox")}
            error={formik.touched.email && Boolean(formik.errors.email)}
            helperText={formik.touched.email && formik.errors.email}
            inputProps={ariaLabel}
          />
          <TextField
            placeholder="Password"
            variant="outlined"
            fullWidth
            type={showPassword ? 'text' : 'password'}
            name="password"
            value={formik.values.password}
            onChange={formik.handleChange}
            className={isMobile ? classes.textInputMobile : (newFlow ? "newInputBoxv2" : "newInputBox")}
            onBlur={formik.handleBlur}
            error={formik.touched.password && Boolean(formik.errors.password)}
            helperText={formik.touched.password && formik.errors.password}
            inputProps={ariaLabel}
            InputProps={{
              endAdornment: <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                  edge="end"
                >
                  {showPassword ? <VisibilityOffOutlined /> : <VisibilityOutlined />}
                </IconButton>
              </InputAdornment>
            }}
          />

          {!showLoader ? (
            <Button
              type="submit"
              variant="contained"
              className={/* isMobile ? "button-after" : */ "new-button"}
              fullWidth
              sx={newFlow ? { marginBottom: "0px !important", marginTop: "8px", height: "40px !important", fontWeight: `600 !important`, fontSize: "16px !important", color: "var(--color-text-primary) !important" } : { mt: "24px", mb: "0px" }}
              disabled={!(formik.isValid && formik.dirty)}
            >
              Sign up {!isMobile && !newFlow && " with email"}
            </Button>
          ) : (
            <Button
              variant="contained"
              className={/* isMobile ? "button-after" : */ "new-button"}
              fullWidth
              sx={{ mt: "24px", mb: "0px" }}
            >
              <ButtonLoader />
            </Button>
          )}
          <FormControlLabel style={{
            gap: "16px",
            alignItems: "flex-start",
            marginLeft: 0,
            marginRight: 0
          }} control={<Checkbox style={{
            padding: "4px 0px 0px"
          }} name="terms_condition" icon={
            <svg width="18.75" height="18.75" viewBox="0 0 29 30" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M28.5625 3.75V26.25C28.5625 26.9959 28.2662 27.7113 27.7387 28.2387C27.2113 28.7662 26.4959 29.0625 25.75 29.0625H3.25C2.50408 29.0625 1.78871 28.7662 1.26126 28.2387C0.733816 27.7113 0.4375 26.9959 0.4375 26.25V3.75C0.4375 3.00408 0.733816 2.28871 1.26126 1.76126C1.78871 1.23382 2.50408 0.9375 3.25 0.9375H25.75C26.4959 0.9375 27.2113 1.23382 27.7387 1.76126C28.2662 2.28871 28.5625 3.00408 28.5625 3.75ZM25.1875 4.3125H3.8125V25.6875H25.1875V4.3125Z" fill={isDarkMode ? 'var(--color-text-primary)' : '#292B2A'} />
            </svg>
          }
            checkedIcon={
              <svg width="18.75" height="18.75" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.18109 17.3189C8.02412 17.1619 7.89961 16.9756 7.81465 16.7705C7.7297 16.5654 7.68598 16.3456 7.68598 16.1236C7.68598 15.9016 7.7297 15.6818 7.81465 15.4767C7.89961 15.2716 8.02412 15.0853 8.18109 14.9283C8.33806 14.7713 8.52442 14.6468 8.72951 14.5618C8.9346 14.4769 9.15442 14.4332 9.37641 14.4332C9.5984 14.4332 9.81821 14.4769 10.0233 14.5618C10.2284 14.6468 10.4147 14.7713 10.5717 14.9283L12.75 17.1094L19.4311 10.4269C19.7481 10.1099 20.1781 9.93176 20.6264 9.93176C21.0747 9.93176 21.5047 10.1099 21.8217 10.4269C22.1387 10.7439 22.3168 11.1739 22.3168 11.6222C22.3168 12.0705 22.1387 12.5005 21.8217 12.8175L13.9467 20.6925C13.7899 20.8498 13.6037 20.9746 13.3985 21.0598C13.1934 21.145 12.9735 21.1888 12.7514 21.1888C12.5293 21.1888 12.3094 21.145 12.1043 21.0598C11.8992 20.9746 11.7129 20.8498 11.5561 20.6925L8.18109 17.3189ZM29.0625 3.75V26.25C29.0625 26.9959 28.7662 27.7113 28.2387 28.2387C27.7113 28.7662 26.9959 29.0625 26.25 29.0625H3.75C3.00408 29.0625 2.28871 28.7662 1.76126 28.2387C1.23382 27.7113 0.9375 26.9959 0.9375 26.25V3.75C0.9375 3.00408 1.23382 2.28871 1.76126 1.76126C2.28871 1.23382 3.00408 0.9375 3.75 0.9375H26.25C26.9959 0.9375 27.7113 1.23382 28.2387 1.76126C28.7662 2.28871 29.0625 3.00408 29.0625 3.75ZM25.6875 4.3125H4.3125V25.6875H25.6875V4.3125Z" fill={isDarkMode ? 'var(--color-text-primary)' : '#292B2A'} />
              </svg>

            } checked={formik.values.terms_condition} onChange={formik.handleChange} sx={{
              '&.Mui-checked': {
                color: "var(--color-new-main)"
              }
            }} /* color={palette.primary.newmain}  */ />} sx={newFlow ? { float: "left", mt: "14px", textAlign: "left" } : { mt: "24px", mb: "36px" }} label={<span style={{
              color: isDarkMode ? 'var(--color-text-primary)' : 'var(--color-text-secondary)'
            }}>By creating an account you are agree to our <a href="https://www.tenacious-tracker.com/terms" target="_blank" style={{
              color: isDarkMode ? 'var(--color-text-primary)' : 'var(--color-text-secondary)'
            }}>Terms & Conditions</a></span>} />
          {formik.touched.terms_condition && <FormHelperText style={{ color: "red" }}>
            {formik.touched.terms_condition && formik.errors.terms_condition
              ? formik.touched.terms_condition && formik.errors.terms_condition
              : " "}
          </FormHelperText>}
        </form>
        <p className={`${isMobile ? "registation_text" : "registation_textv2"}`} style={newFlow ? { marginTop: "22px" } : {}}>
          <span style={{ color: isDarkMode ? 'var(--color-text-primary)' : 'var(--color-text-secondary)' }}>{isMobile ? 'or sign up with' : "or"}</span>
        </p>
        <Grid className={isMobile ? classes.socialLoginButton : classes.socialLoginButtonWeb}>
          <Button
            sx={isMobile ? { padding: 0 } : {
              width: "130px",
              height: "48px",
              gap: "8px",
              borderRadius: "12px",
              border: "1px solid var(--color-border)",
              padding: "0px",
            }}
            onClick={() => handleOnClick(googleProvider)}
          >
            <NewGoogleIcon />
          </Button>
          {/* <Button
            sx={{ padding: 0 }}
            onClick={() => handleOnClick(facebookProvider)}
          >
            <NewFacebookIcon />
          </Button> */}

        </Grid>
        {!newFlow && <p className={classes.alreadyAccountText}>
          Already a user?{" "}
          <span
            className={classes.alreadyAccountTextSpan}
            onClick={() => navigate("/login" + queryData.qeryString)}
          >
            {isMobile ? "Log in" : "Log in"}
          </span>
        </p>}
      </Grid>
    </Root >
  );
};
export default RightPartRegistration;
